import React from 'react'
import PropTypes from 'prop-types'
import './ShipSelect.scss'

import downArrow from '../../assets/images/down-arrow-icon.svg'

const ShipSelect = ({ ships, setCurrentShipCode, currentShipCode }) => {
  const handleChange = e => {
    setCurrentShipCode(e.target.value)
  }

  return (
    <div className="ship-select-basic">
      <select onChange={handleChange} defaultValue={currentShipCode}>
        <option key="ship-option-none" value="">
          Ship
        </option>
        {ships.map(ship => (
          <option key={`ship-option-${ship.id}`} value={ship.id}>
            {ship.name}
          </option>
        ))}
      </select>
      <img
        src={downArrow}
        className="ship-select-basic__icon"
        alt="ship select dropdown icon"
      />
    </div>
  )
}

ShipSelect.propTypes = {
  ships: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
  setCurrentShipCode: PropTypes.func.isRequired,
  currentShipCode: PropTypes.string.isRequired,
}

export default ShipSelect
